import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Sidebar from "components/Panel/Reseller/Sidebar";
import { useSelector, useDispatch } from "react-redux";
import { profile } from "redux/reseller/profile/profileSlice"
import { settings } from "redux/reseller/settings/settingsSlice"
import { Helmet } from "react-helmet";

function DashboardLayout() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { user, role } = useSelector((state) => state.resellerAuth);
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);

  const handleToggleSidebar = () => {
    setIsSidebarExpanded(!isSidebarExpanded);
  };

  useEffect(() => {
    dispatch(profile());
    dispatch(settings());
  }, [dispatch])

  useEffect(() => {
    setIsSidebarExpanded(false);
  }, [location])

  if (!user || role !== "reseller") {
    return <Navigate to="/login/reseller" />;
  }

  return (
    <div className="min-h-screen flex bg-black">
      <Helmet>
        <title>SkyPay | Bayi Paneli</title>
        <meta name="description" content="SkyPay | Bayi Paneli" />
      </Helmet>
      <Sidebar toggle={isSidebarExpanded} />
      <main className="md:ml-20 w-full">
        <div className="text-white-100 ml-4 my-2 inline-block md:hidden bg-primary px-4 py-1 font-semibold rounded-md " onClick={handleToggleSidebar}>Menü</div>
        <Outlet />
      </main>
      <ToastContainer autoClose={2000} />
    </div>
  );
}

export default DashboardLayout;
